import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { HeaderComponent } from './share/header/header.component';
import { FooterComponent } from './share/footer/footer.component';
import { SliderComponent } from './share/slider/slider.component';
import { HomeComponent } from './home/home.component';
import { CorporateComponent } from './corporate/corporate.component';
import { EvusliderComponent } from './home/evuslider/evuslider.component';
import { HomeboxComponent } from './share/homebox/homebox.component';
import { HumanresourcesComponent } from './humanresources/humanresources.component';
import { ServicesComponent } from './services/services.component';
import { ProcessComponent } from './process/process.component';
import { ContactComponent } from './contact/contact.component';

const appRoutes: Routes = [
  {
    path: "",
    component: HomeComponent,
    pathMatch: "full"
  },
  {
    path: "kurumsal",
    component: CorporateComponent
  },
  {
    path: "insan-kaynaklari",
    component: HumanresourcesComponent
  },
  {
    path: "hizmetlerimiz",
    component: ServicesComponent
  },
  {
    path: "proses-ayrintilari",
    component: ProcessComponent
  },
  {
    path: "iletisim",
    component: ContactComponent
  }
]

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SliderComponent,
    HomeComponent,
    CorporateComponent,
    EvusliderComponent,
    HomeboxComponent,
    HumanresourcesComponent,
    ServicesComponent,
    ProcessComponent,
    ContactComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes)
  ],
  providers: [
    Title
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/app/app.module.ts